import React from 'react'
import CarouselPageModal from '../pages/Instructions/CarouselPageModal/CarouselPageModal'
import useContentStack from '../hooks/useContentStack'
import { ContentStackTypes } from '../store/Constants'
import { CmsDataFetchStatus } from '@jarvis/olex-content-management'

export const WhereIsTheProductNameModal = ({ open, onClose }) => {
  const parseContentStackModalData = (data) => {
    return {
      header: data?.header,
      cards:
        data?.cards?.map((item) => ({
          illustration: item?.card?.illustration?.url,
          instruction: item?.card?.instruction
        })) || []
    }
  }

  const {
    status: wheresProductNameModalStatus,
    pageData: pageWheresProductNameModalData
  } = useContentStack(
    ContentStackTypes.carousel_modal_wheres_product_name,
    parseContentStackModalData
  )

  if (wheresProductNameModalStatus === CmsDataFetchStatus.LOADING) {
    return <></>
  }

  return (
    <CarouselPageModal
      pageData={pageWheresProductNameModalData}
      show={open}
      instruction="wheres_product_name"
      onClose={onClose}
      currentCardIndex={-1}
    />
  )
}
